/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-observers, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { isArray } from '@ember/array';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { observes } from '@ember-decorators/object';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';
import ApplicationStatus from 'linced-app/enums/application-status';

export default class BaseProcessor extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  caregiverFields = [];
  relationshipFields = [];
  medicalFields = [];
  medicalRelationshipFields = [];

  @tracked
  step = 0;

  @action
  setStep(value) {
    this.step = value;
  }

  @tracked
  startDate = '';

  @action
  setStartDate(value) {
    this.startDate = value;
  }

  @tracked
  processing = false;

  @tracked
  processed = false;

  @tracked
  contactMappingSkipped = false;

  @computed('contacts.@each.processing')
  get contactMappingInProgress() {
    if (!isArray(this.contacts)) {
      return false;
    }
    return this.contacts.some((contact) => contact.processing);
  }

  @tracked
  contacts = null;

  @tracked
  medicalContacts = null;

  @tracked
  learner;

  @tracked
  newPersonId;

  @observes('step')
  stepChanged() {
    switch (this.step) {
      case 1:
        this.process();
        break;
    }
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    this.set('step', 0);
  }

  onComplete() {}
  onCancel() {}

  @action
  setPersonId(personId) {
    this.application.set('personId', personId);
    return this.application.save().then(() => {
      // After persisting the personId, move to the next step.
      this.incrementProperty('step');
    });
  }

  @action
  cancel() {
    this.onCancel();
  }

  process() {
    this.processing = true;
    this.createEnrolment(this.application, this.startDate)
      // A failed create is discarded, so the application doesn't keep it as its
      // enrolment (and send a null id for it on its next save).
      .then((enrolment) => saveOrDiscard(enrolment))
      .then((enrolment) => {
        let application = this.application;
        let newPersonId = enrolment.get('personId');
        this.newPersonId = newPersonId;
        application.set('status', ApplicationStatus.ACCEPTED);
        if (!isEmpty(newPersonId)) {
          application.set('personId', newPersonId);
        }
        return application.save().then(() => {
          this.onComplete();
          return this.store.findRecord('person', enrolment.get('personId'));
        });
      })
      .then((person) => {
        let { contacts, medicalContacts } = this.processContacts(false);
        if (contacts === false && medicalContacts === false) {
          this.contactMappingSkipped = true;
        } else {
          this.contacts = contacts;
          this.medicalContacts = medicalContacts;
        }
        this.processed = true;
        this.processing = false;
        this.learner = person;
      })
      .catch(() => {
        this.processing = false;
        this.toaster.error('Error processing the application.');
      });
  }
}
